<a class="d-flex justify-content-center align-items-center brand-wrapper p-3 w-100" [routerLink]="brandUrl()">
  <img class="brand-img" [src]="brand().logo" [alt]="brand().name">
</a>